<h1 mat-dialog-title cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>Rediger fast ordre note</h1>
<button class="btn-close btn-icon" mat-dialog-close title="Luk dialog">
  <mat-icon class="material-icons">close</mat-icon>
</button>
<div mat-dialog-content>
  <form [formGroup]="form" autocomplete="off">
    <div class="form-row">
      <mat-form-field appearance="outline" class="mdc-textarea-fix">
        <textarea id="fastOrdreNote" formControlName="fastOrdreNote" rows="5" matInput></textarea>
        <mat-hint align="end">
          <app-character-count [control]="fastOrdreNote" maxlength="500"></app-character-count>
        </mat-hint>
        @if (fastOrdreNote.hasError('maxlength')) {
          <mat-error>Fast ordre note må højest være 500 karakterer lang</mat-error>
        }
      </mat-form-field>
    </div>
  </form>
</div>
<div mat-dialog-actions class="row-reverse">
  <button mat-raised-button color="primary" (click)="save()" [disabled]="form.invalid">Gem</button>
  <button (click)="cancel()" class="modal-cancel" mat-raised-button>Fortryd</button>
</div>
